import React from 'react';
import PropTypes from 'prop-types';
import Font from '@mui/icons-material/HowToReg';
import { Card, IconButton } from '@totalsoft/rocket-ui';
import { useTranslation } from 'react-i18next';
import { Table, TableCell, TableBody, TableRow, TableHead } from '@mui/material';
import ApprovalTypeLevelListItemComponent from './ApprovalTypeLevelListItemComponent';

const ApprovalTypeLevelListComponent = ({ onAdd, approvalTypeLevels, onEdit, onDelete }) => {
  const { t } = useTranslation();
  return (
    <Card
      icon={Font}
      iconColor='primary'
      title={t('ApprovalTypes.ApprovalTypeLevels')}
      actions={
        <IconButton type='add' fontSize='medium' color='transparent' tooltip={t('Tooltips.ApprovalTypeLevel.Add')} onClick={onAdd} />
      }
    >
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>{t('ApprovalTypes.ApprovalTypeLevel.OrderNo')}</TableCell>
            <TableCell>{t('ApprovalTypes.ApprovalTypeLevel.Level')}</TableCell>
            <TableCell>{t('ApprovalTypes.ApprovalTypeLevel.DefaultEmployee')}</TableCell>
            <TableCell align='right'>{t('ApprovalTypes.Actions')}</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {approvalTypeLevels.map((item, idx) => {
            return <ApprovalTypeLevelListItemComponent key={idx} item={item} onEdit={onEdit} onDelete={onDelete} index={idx} />;
          })}
        </TableBody>
      </Table>
    </Card>
  );
};

ApprovalTypeLevelListComponent.propTypes = {
  onEdit: PropTypes.func.isRequired,
  onAdd: PropTypes.func.isRequired,
  approvalTypeLevels: PropTypes.array.isRequired,
  onDelete: PropTypes.func.isRequired
};

export default ApprovalTypeLevelListComponent;
